export const leftContent = [
  {
    id: 1,
    img: require("../../../image/etoro/cse-lft-img-one.webp"),
    activeImg: require("../../../image/etoro/cse-lft-img-one-active.webp"),
    title: "Customizable Design",
  },
  {
    id: 2,
    img: require("../../../image/etoro/cse-lft-img-two.webp"),
    activeImg: require("../../../image/etoro/cse-lft-img-two-active.webp"),
    title: "Advanced Security Features",
  },
  {
    id: 3,
    img: require("../../../image/etoro/cse-lft-img-three.webp"),
    activeImg: require("../../../image/etoro/cse-lft-img-three-active.webp"),
    title: "Scalable Architecture",
  },
  {
    id: 4,
    img: require("../../../image/etoro/cse-lft-img-four.webp"),
    activeImg: require("../../../image/etoro/cse-lft-img-four-active.webp"),
    title: "Integrated Copy Trading",
  },
  {
    id: 5,
    img: require("../../../image/etoro/cse-lft-img-five.webp"),
    activeImg: require("../../../image/etoro/cse-lft-img-five-active.webp"),
    title: "User-Friendly Interface",
  },
];

export const rightImages = [
  require("../../../image/etoro/choose-right-one.webp"),
  require("../../../image/etoro/choose-right-two.webp"),
  require("../../../image/etoro/choose-right-three.webp"),
  require("../../../image/etoro/choose-right-four.webp"),
  require("../../../image/etoro/choose-right-five.webp"),
];

export const chooseDescriptions = [
  "Tailor the platform’s appearance and functionality to reflect your brand’s identity.",
  "Protect your users’ data and funds with multi-layered security protocols.",
  "Expand your platform effortlessly as your user base grows.",
  "Provide users with the ability to replicate successful trades with our eToro copy trading clone feature.",
  "Simplify the trading process with an intuitive and interactive user experience.",
];
